
import { useState, useEffect } from 'react';
import VideoUploader from '../../../components/feature/VideoUploader';

const Hero = () => {
  const [backgroundVideo, setBackgroundVideo] = useState<string | null>(null);

  // 載入已保存的視頻
  useEffect(() => {
    const loadSavedVideo = async () => {
      const cacheKey = localStorage.getItem('hero-video-key');
      if (cacheKey) {
        try {
          const cache = await caches.open('video-cache');
          const response = await cache.match(cacheKey);
          if (response) {
            const blob = await response.blob();
            const videoUrl = URL.createObjectURL(blob);
            setBackgroundVideo(videoUrl);
          }
        } catch (error) {
          console.log('載入視頻失敗:', error);
        }
      }
    };

    loadSavedVideo();
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景視頻或圖片 */}
      {backgroundVideo ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      ) : (
        <div 
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/daf2c8ebc95be5bc3480a922a1310657/78f5b99cf0f3dcaef868131c73dd3a73.png)'
          }}
        />
      )}
      
      {/* 遮罩層 */}
      <div className="absolute inset-0 bg-black/30" />
      
      {/* 內容 */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <div className="bg-black/50 backdrop-blur-sm rounded-2xl p-8 md:p-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            嚴家淦先生紀念協會
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            紀念故總統嚴家淦先生冥誕120歲紀念活動<br />
            新書發表暨3D數位典藏開香活動
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#exhibition"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              了解活動
            </a>
            <a 
              href="#about"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              協會介紹
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
